/**
 * Qué clase de comisionista es cada uno.
 *
 * Los nombres no vienen del swagger —el enum viaja como número pelado— sino de la
 * descripción de los endpoints que lo filtran, que los deletrea:
 * "(1 practitioner, 2 staff, 3 provider, 4 other)".
 *
 * https://prebiller.hc.alpha-cr.com/apis/prebiller-gateway/swagger/docs/v1/contracts
 */
export enum CommissionAgentTypeEnum {
  /** Profesional médico: el único tipo que existía antes de que la API aceptara el resto. */
  Practitioner = 1,
  Staff = 2,
  Provider = 3,
  Other = 4
}

/**
 * Los cuatro tipos en el orden en que se ofrecen, con su clave de traducción.
 *
 * El profesional va primero porque es el caso habitual y porque es el único que el
 * contrato ya conocía; los demás se agregaron después.
 */
export const CommissionAgentTypeOptions = [
  {
    key: CommissionAgentTypeEnum.Practitioner,
    textKey: 'commissionAgentType.practitioner',
    defaultText: 'Profesional'
  },
  {
    key: CommissionAgentTypeEnum.Staff,
    textKey: 'commissionAgentType.staff',
    defaultText: 'Staff'
  },
  {
    key: CommissionAgentTypeEnum.Provider,
    textKey: 'commissionAgentType.provider',
    defaultText: 'Proveedor'
  },
  {
    key: CommissionAgentTypeEnum.Other,
    textKey: 'commissionAgentType.other',
    defaultText: 'Otro'
  }
];

/**
 * Si el comisionista es un profesional médico.
 *
 * Es la distinción que separa las dos mitades de la solapa: los profesionales del
 * protocolo ya se listan con su rol de estudio y su ficha, y el resto —staff,
 * proveedores y otros— no tiene nada de eso y se lista aparte.
 *
 * Un agente sin tipo se toma como profesional: los que se cargaron antes de que la
 * API tuviera el campo son todos profesionales, porque no había otra cosa.
 */
export const IsPractitionerAgent = (type: CommissionAgentTypeEnum | undefined | null): boolean =>
  type === undefined || type === null || type === CommissionAgentTypeEnum.Practitioner;
